import { render, staticRenderFns } from "./PostDetailFriendAccept.vue?vue&type=template&id=2c71a3bc&scoped=true"
import script from "./PostDetailFriendAccept.vue?vue&type=script&lang=js"
export * from "./PostDetailFriendAccept.vue?vue&type=script&lang=js"
import style0 from "./PostDetailFriendAccept.vue?vue&type=style&index=0&id=2c71a3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c71a3bc",
  null
  
)

export default component.exports